import { IcoClose, IcoEdit } from './common/Icons.jsx';
import { nombreDe } from '../store/cartStore.js';
import styles from './MoveTabSheet.module.css';

/**
 * A quién se le apunta lo que se toque en el catálogo.
 *
 * En teléfono sustituye a la fila de chips que iba pegada a la hoja: con
 * cuatro comensales el cuarto ya quedaba fuera de una pantalla de 360 px y
 * había que deslizar para saber a quién se le estaba cargando. Aquí se ve
 * la mesa completa de un vistazo, un toque elige y la hoja se cierra sola.
 */
export default function ApuntarASheet({ open, seats = [], comensales = [], activeSeat, onElegir, onAgregar, onEditar, onClose }) {
  if (!open) return null;

  const elegir = (n) => { onElegir(n); onClose(); };

  return (
    <div className={styles.scrim} role="presentation" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.sheet} role="dialog" aria-modal="true">
        <div className={styles.head}>
          <div>
            <h2 className={styles.title}>¿A quién le apunto?</h2>
            <p className={styles.sub}>Lo que toques en el catálogo se le carga a esta persona</p>
          </div>
          <button className={styles.close} onClick={onClose} aria-label="Cerrar"><IcoClose size={16} /></button>
        </div>

        <div className={styles.chipsGrid}>
          <button
            className={`${styles.chipBig} ${!activeSeat ? styles.chipBigOn : ''}`}
            onClick={() => elegir(null)}
            aria-pressed={!activeSeat}
          >
            Mesa<small>se comparte</small>
          </button>
          {seats.map((n) => (
            <div key={n} className={styles.chipWrap}>
              <button
                className={`${styles.chipBig} ${activeSeat === n ? styles.chipBigOn : ''}`}
                onClick={() => elegir(n)}
                aria-pressed={activeSeat === n}
              >
                {nombreDe(n, comensales)}
              </button>
              {/* Ponerle nombre desde aquí: es el momento en que el mesero lo
                  necesita ("¿cuál era la señora?"), no en otra pantalla. */}
              <button className={styles.chipEdit} onClick={() => onEditar(n)} aria-label={`Editar ${nombreDe(n, comensales)}`}>
                <IcoEdit size={14} />
              </button>
            </div>
          ))}
          <button
            className={styles.chipBigGhost}
            onClick={() => { const n = onAgregar(); if (n) elegir(n); }}
          >
            + comensal
          </button>
        </div>
      </div>
    </div>
  );
}
